// extracted by mini-css-extract-plugin
export default {"footnotes":"footnotes_footnotes__aR06l","footnotes_sub_section":"footnotes_footnotes_sub_section__0P+g-"};